import { DateTime } from "luxon";
import * as Yup from "yup";

import {
  dateInterval,
  isFirstDateAfterOrEqualToSecondDate,
} from "../../../../utils/dateFormatter";

export type ViewType = "details" | "summary";

export interface RequirementsSearchBarValues {
  fromProcessDate: string;
  toProcessDate: string;
  view: ViewType;
}

export const dateValidation = () =>
  Yup.string().test({
    message: "Invalid date",
    test: isPassingValidDate,
  });

const DISPLAY_DATE_FORMAT = "MM/dd/yyyy";

const MAX_PROCESS_DATE_INTERVAL = 7;
const dateShort = (date: string): DateTime =>
  DateTime.fromFormat(date, DISPLAY_DATE_FORMAT);

export function isPassingValidDate(dateValue?: string | Date) {
  const isValidJSDate =
    dateValue instanceof Date && DateTime.fromJSDate(dateValue).isValid;

  if (dateValue === undefined) return true;

  if (typeof dateValue === "string" && dateValue?.length === 0) return true;

  if (typeof dateValue === "string" && dateValue)
    return (
      !!dateValue &&
      !!DateTime.fromFormat(dateValue, DISPLAY_DATE_FORMAT).isValid
    );

  if (isValidJSDate) return true;

  return false;
}
export const fromProcessDateValidation = dateValidation()
  .test(
    "max days",
    `Maximum ${MAX_PROCESS_DATE_INTERVAL} days`,
    (value, context) => {
      const interval = dateInterval(value, context.parent.toProcessDate);

      if (interval) {
        return interval <= MAX_PROCESS_DATE_INTERVAL;
      }
      return true;
    }
  )
  .test("notFutureDate", "Cannot be future date", date => {
    if (!date) return true;
    return dateShort(date) < DateTime.now();
  })
  .required("Required");

export const toProcessDateValidation = dateValidation()
  .test(
    "From must be before or equal to To date",
    "Invalid date pair",
    (value, context) =>
      isFirstDateAfterOrEqualToSecondDate(value, context.parent.fromProcessDate)
  )
  .test("notFutureDate", "Cannot be future date", date => {
    if (!date) return true;
    return dateShort(date) < DateTime.now();
  })
  .required("Required");

export const searchBarSchema: Yup.SchemaOf<RequirementsSearchBarValues> =
  Yup.object().shape({
    fromProcessDate: fromProcessDateValidation,
    toProcessDate: toProcessDateValidation,
    view: Yup.mixed<ViewType>().required().default("details"),
  });
